import { render, staticRenderFns } from "./MainContentLoading.vue?vue&type=template&id=b491509e&scoped=true&"
import script from "./MainContentLoading.vue?vue&type=script&lang=js&"
export * from "./MainContentLoading.vue?vue&type=script&lang=js&"
import style0 from "./MainContentLoading.vue?vue&type=style&index=0&id=b491509e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b491509e",
  null
  
)

export default component.exports